// extracted by mini-css-extract-plugin
export default {"heading":"QSRVx","h500":"_4rpBu","h400":"Zd-ef","h300":"_62Va6","h200":"FfpFl","h100":"E4cbB"};